<template>
  <basic-card class="new-basic-card" hideHeader :hasMore="showMore">
    <avue-crud
      class="global-table"
      :key="tableKey"
      :option="option"
      :data="data"
      :page="page"
      v-model="form"
      v-model:search="search"
      :table-loading="scopeLoading"
      ref="crud"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @select-all="handleSelectAll"
      @on-load="onLoad"
    >
    <template #select-header="{ row }">
      <CompRadio 
          v-model="selectAll" 
          label=""
          allow-uncheck
          @change="(val) => selectAll = false"
        />
    </template>
      <template #select="{ row }">
        <CompRadio 
          v-model="row.frontEnd_select" 
          label=""
          allow-uncheck
          @change="(val) => handleSelect(val, row)"
        />
      </template>
      <template #scopeType="{ row }">
        <el-tag>{{ row.scopeTypeName }}</el-tag>
      </template>
      <template #status="{ row }">
        <OnlineStatus radius="2px"
          :showPoint="false"
          upperCase
          onlineBlue
          :list="commStatusList"
          :commStatus="row.commStatus">
        </OnlineStatus>
      </template>
      <template #modelId="{ row }">
        {{ row.modelName }}
      </template>
      <template #nameOrSn-search="{ row }">
        <CompSearch :placeholder="Lang.Text.dimensionSearchDeviceName"
          v-model="search.nameOrSn"
          @change=" (val) => { this.onLoad(this.page, {nameOrSn: val }) }"
          >
        </CompSearch>
      </template>

    </avue-crud>
  </basic-card>
  
</template>

<script>
import {
  getDetail,
  submit,
  remove,
} from '@/api/gateway/measurementPoint';
import { getItemPage } from '@/api/gateway/device';
import { mapGetters } from 'vuex';
import { filterDollarKeys } from '@/utils/util';
import { getLanguage, Lang } from '@/lang/lang';
import CompRadio from '@/components/comp-radio/index.vue';
import OnlineStatus from '@/views/gatewayManage/comps/OnlineStatus';
import { getDictionary } from '@/api/system/dict';
import CompSearch from '@/components/comp-search/index.vue';


export default {
  name: 'SelectGateWay',
  props: {
    selectedDevice: {
      type: Array,
      default() {
        return [];
      },
    },
    dimensionType: {
      type: String,
      default: ''
    },
    deptId: {
      type: String,
      default: ''
    },
  },
  components: {
    CompRadio,
    OnlineStatus,
    CompSearch
  },
  data() {
    return {
      selectAll: false,
      currentLangKey: this.language,
      tableKey: 0,
      form: {},
      localDimensionType: '',
      itemId: '',
      operation: 'add',
      commStatusList: [],
      selectionList: [],
      query: {},
      search: {},
      showAddMeasurementPoint: false,
      loading: true,
      showMore: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      drawerVisible: false,
      direction: 'rtl',
      scopeLoading: false,
      scopeMenuId: 0,
      scopeMenuName: this.Lang.label.menu,
      menu: true,
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        tip: false,
        searchShow: true,
        searchSpan: 12,
        searchMenuSpan: 6,
        searchLabelWidth: 'auto',
        gutter: 20,
        border: true,
        index: false,
        emptyBtn: false,
        searchBtn: false,
        border: false, // 关键
        menuWidth: 146, // 操作列宽
        addBtn: true, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        selection: false,
        menuWidth: 116,
        // dialogWidth: 900,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        dialogClickModal: false,
        menu: false,
        // selectable: true,
        selectable: (row, index) => {
          return !this.selectionList.length || row.id == this.selectionList[0]?.id;
        },
        // labelPosition: 'top',
        column: [
          {
            label: '',
            prop: 'nameOrSn',
            search: true,
            display: false,
            hide: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
            type: 'search',
            span: 24,
            placeholder: this.Lang.Text.dimensionSearchDeviceName,
            oninput: (e) => {
              this.onLoad(this.page, this.search);
            },
          },
          {
            label: '',
            prop: 'select',
            slot: true
          },
          {
            label: this.Lang.Title.dimensionDeviceName,
            prop: 'name',
            search: false,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
            oninput: (e) => {
              this.onLoad(this.page, this.search);
            },
            change: (e) => {
              if (!e.value) {
                this.onLoad(this.page, {});
              }
            },
          },
          {
            label: this.Lang.Title.dimensionGw,
            prop: 'deviceName',
            search: false,
          },
          {
            label: this.Lang.Title.dimensionGwGroup,
            prop: 'groupName',
            search: false,
          },
          {
            label: this.Lang.Title.dimensionDeviceSn,
            prop: 'sn',
            search: false,
            oninput: (e) => {
              this.onLoad(this.page, {sn: e.data});
            },
            change: (e) => {
              if (!e.value) {
                this.onLoad(this.page, {});
              }
            },
          },
          {
            label: this.Lang.Title.dimensionModel,
            prop: 'modelId',
            slot: true,
            search: false,
          },
          {
            label: this.Lang.Title.dimensionStatus,
            prop: 'status',
            search: false,
            slot: true,
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission', 'language']),
    CURRENT_LANGUAGE() {
      return getLanguage(this.language);
    },
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    scopeIds() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.getCommStatusList()
  },
  mounted() {
    this.search.language = this.language; // 默认当前语言
  },
  methods: {
    getCommStatusList() {
      getDictionary({code: 'commStatus'}).then(res => {
        const data = res.data.data;
        this.commStatusList = data;
      })
    },
    // 自定义查看
    handleView(row) {
      this.operation = 'view';
      this.itemId = row.id;
      this.showAddMeasurementPoint = true;
    },
    // 自定义编辑
    handleEdit(row) {
      this.operation = 'edit';
      this.itemId = row.id;
      this.showAddMeasurementPoint = true;
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    handleSelect(val, row) {
      this.data.forEach(item => {
        if (item.id != row.id) {
          item.frontEnd_select = false;
        }
      })
      if (val) {
        this.selectionList = [row]
      }
    },
    // 自定义搜索
    handleSearch() {
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    fetchRemoteIds(query) {
      if (!query) return;
      const page = this.page;
      // 调用后端接口获取匹配的 ID 列表
      getItemPage(page.currentPage, page.pageSize, query, this.currentLangKey).then((res) => {
        const data = res.data.data.records || [];
        // 更新字典数据
        this.option.column.find((col) => col.prop === 'id').dicData = data.map((item) => ({
          id: item.id,
          name: item.name || item.id, // 显示名称
        }));
      });
    },
    handleSelectAll(row) {
      return false;
      console.log(row)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.operation = 'add';
      this.showAddMeasurementPoint = true;
    },
    filterChange(filter) {
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    getSelectedDevice() {
      const selectedDevice = this.selectionList;
      return selectedDevice;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    treeLoad(tree, treeNode, resolve) {
      const parentId = tree.id;
      getLazyMenuList(parentId).then(res => {
        resolve(res.data.data);
      });
    },
    onCancel() {
      this.showAddMeasurementPoint = false;
    },
    onSubmit(params) {
      submit(params).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.onLoad(this.page, this.query);
          this.showAddMeasurementPoint = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 无用的函数，保留
    rowSave(row, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowUpdate(row, index, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowDel(row) {
      this.$confirm( this.Lang.tips.ifConfirmDelete, 'Delete Measurement Point', {
        content: this.Lang.tips.ifConfirmDelete,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    // 无用的函数，保留
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.scopeIds);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess, 
          });
          this.$refs.crud.toggleSelection();
        });
    },
    // 无用的函数，保留
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({id: this.form.id}).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
      };
      if (this.dimensionType === 'AreaEnergy') {
      } else if (this.dimensionType === 'Environment') {
        values.iotProduct = 'environmental_sensor';
      } else if (this.dimensionType === 'Photovoltaic') {
        // 待产品提才过滤
      }
      if (this.deptId) {
        values.deptId = this.deptId;
      }
      getItemPage(page.currentPage, page.pageSize, Object.assign(values, this.query), this.currentLangKey).then(
        res => {
          const data = res.data.data;
          this.page.total = data.total;
          data.records.forEach(item => {
            item.frontEnd_select = false;
          })
          this.data = data.records;
          this.scopeLoading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>
